import React, { useCallback } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CurrencyInput } from 'ui-components/components/currency-input';

import FormattedCurrencyContainer from '../../../../../../components/formatted-currency/container';
import { getDecimalsToDisplayFromPrice } from '../../../../../../services/decimal-display-service';
import { MINIMUM_PURCHASE_AMT } from '../../constants/add-funds-constants';
import messages from '../messages';
import styles from '../style.module.less';

export const AddFundsConfirmationModalBody = ({ currentBalance, currencyCode, amount, setAmount, setIsDisabled }) => {
  const isBelowMinimumValue = amount < MINIMUM_PURCHASE_AMT;

  const updateOtherAmpount = useCallback(
    (value) => {
      let numberValue = Number(value);
      if (Number.isNaN(numberValue)) {
        numberValue = 0;
      }
      if (numberValue < MINIMUM_PURCHASE_AMT) {
        setIsDisabled(true);
      }
      if (numberValue >= MINIMUM_PURCHASE_AMT) {
        setIsDisabled(false);
      }
      setAmount(numberValue);
    },
    [setAmount, setIsDisabled],
  );
  return (
    <div>
      <div className={styles['body-content']}>
        <div className={styles.title}>
          <FormattedMessage {...messages.addFundsModalHeader} />
        </div>
        <div className={styles.amount}>
          <FormattedCurrencyContainer
            currencyCode={currencyCode}
            fractionDigits={getDecimalsToDisplayFromPrice(currentBalance)}
            value={currentBalance}
          />
        </div>
      </div>
      <div className={styles['note-text']}>
        <FormattedMessage {...messages.addFundsNote} />
      </div>
      <div>
        <CurrencyInput
          className={styles['currency-funds']}
          currencyCode={currencyCode}
          onChange={updateOtherAmpount}
          showPlaceHolderForZero
          value={amount}
        />
      </div>
      <div className={classNames(styles['note-text'], { [styles['amount-error']]: isBelowMinimumValue }, styles.hint)}>
        {isBelowMinimumValue ? <FontAwesomeIcon className={styles['error-icon']} icon={faExclamationCircle} /> : null}{' '}
        <FormattedMessage
          {...messages.minimumFundsToAdd}
          values={{
            minimum: <FormattedCurrencyContainer currencyCode={currencyCode} fractionDigits={0} value={10} />,
          }}
        />
      </div>
    </div>
  );
};

AddFundsConfirmationModalBody.propTypes = {
  currentBalance: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  setAmount: PropTypes.func.isRequired,
  setIsDisabled: PropTypes.func.isRequired,
};
